export function isValueNullOrEmpty(value: any): boolean {
    if (value === null || value === undefined) {
      return true;
    }
  
    // Check for empty string
    if (typeof value === 'string' && value.trim() === '') {
      return true;
    }
  
    // Check for empty array
    if (Array.isArray(value) && value.length === 0) {
      return true;
    }
  
    // Check for empty object
    if (typeof value === 'object' && Object.keys(value).length === 0) {
      return true;
    }
  
    return false;
  }
  
  function isStringNullOrEmpty(value: any): boolean {
    return value === null || value === undefined || value === '';
  }

  export function downloadCSV(data: string[], fileName: string): void{
    let csvArray = data.join('\r\n');
    let d = new Date();
    let dformat = `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}(${d.getHours()}_${d.getMinutes()}_${d.getSeconds()})`;
    let theName = `${fileName}_${dformat}` + '.csv';
    var blob = new Blob([csvArray], { type: 'text/csv' });
    const link = document.createElement('a');
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', theName);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }